import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Input, Row, Table, Typography } from "antd";

import { CSVLink } from "react-csv";

import { useReactToPrint } from "react-to-print";

const { Search } = Input;
const { Title, Text } = Typography;

const ListLot = (props) => {
  const [filterData, setFilterData] = useState(null);
  const [lignesCSV, setLignesCSV] = useState(null);
  const { listData, tableOption } = props;

  const componentRef = useRef();

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData]);

  const init = () => {
    const lignesCSV = listData?.map((data) => {
      const ligne = {
        lot_id: data.lot_id,
        lot_reference: data.lot_reference,
        proprietaire_code: data.lot_proprietaire.proprietaire_code,
        lot_proprietaire: data.lot_proprietaire.proprietaire_personne.personne_nom,
        lot_adresse: data.lot_adresse.adresse_gmaps_adresse,
        lot_nb_pieces: data.lot_nb_pieces,
        lot_numero_mandat: data.lot_numero_mandat,
      };

      data.lot_champs_persos
        .filter((champ) => champ.lot_champ_perso_champ_perso.champ_perso_liste_lot)
        .forEach((champ) => {
          ligne[
            champ.lot_champ_perso_champ_perso.champ_perso_libelle.toLowerCase().replace(/\s+/g, "_")
          ] = champ.lot_champ_perso_valeur;
        });

      return ligne;
    });

    setLignesCSV(lignesCSV);
  };

  const search = (value) => {
    const { listData } = props;

    const filterData = listData.filter((o) => {
      return Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()));
    });

    setFilterData(value ? filterData : listData);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div style={{ padding: 20 }}>
        <Row>
          <Title level={2}>Liste des Lots</Title>
        </Row>
        <Row>
          <Col span={5}>
            <Search
              placeholder="Recherche..."
              allowClear
              onSearch={search}
              style={{ width: 300 }}
            />
          </Col>
          <Col offset={14} span={2}>
            <Text mark>{`Nombre de lot(s): ${
              filterData ? filterData.length : listData ? listData.length : 0
            }`}</Text>
          </Col>
          <Col span={3}>
            <div style={{ float: "right" }}>
              <Button onClick={handlePrint} className="btn-primary">
                PDF
              </Button>
              {lignesCSV && (
                <Button style={{ marginLeft: 10 }}>
                  <CSVLink
                    filename={"export.csv"}
                    data={lignesCSV}
                    // headers={headers()}
                    separator={";"}
                  >
                    Export CSV
                  </CSVLink>
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div ref={componentRef}>
        {listData && (
          <Table
            className="list-data"
            dataSource={filterData ? filterData : listData}
            columns={tableOption}
            pagination={false}
            rowKey="lot_id"
          />
        )}
      </div>
    </>
  );
};

export default ListLot;
